export default (s) => {
  return s.replace(/ *\([^)]*\) */g, '')
}
